import { DynamicFormControlDivComponent } from "./dynamic-form-control-div.component";

export abstract class DynamicFormGroupDivComponent extends DynamicFormControlDivComponent {

    
}
